<template>

<core-modal-setting :title="setting.name" :value="valueText" :placeholder="setting.placeholder">
        
    <template v-if="setting.type === 'checklist'">

        <core-input-checklist 
            :options="setting.options"
            v-model="internalValue"
        />

    </template>
        
    <template v-if="setting.type === 'percent'">

        <core-input-textbox 
            maxlength="3" 
            placeholder="Enter percent" 
            v-model="internalValue"
        />

    </template>

</core-modal-setting>

</template>

<script>

import mixSetting from 'core/mixin/modal/Setting'

export default {

    mixins: [mixSetting]

}

</script>

<style scoped>

</style>